import Dictionary from "~/ts/library/Dictionary";
import {Component} from "vue";

export interface OperatorApplicationMenuItem {
    sectionId: string;
    component: Component;
    props?: Dictionary<any>;
    descr: string,
    icon: string,
    badgeValueGetter?: () => number | string | null,
}

export interface OperatorApplicationMenuSection {
    sortable: boolean;
    items: OperatorApplicationMenuItem[]
}

export const OPERATOR_APPLICATION_MENU_ITEM_BUDDY_LIST_ID_KEY = "buddyListId"
export const OPERATOR_APPLICATION_MENU_ITEM_BUDDY_LIST_KEY = "buddyList"